import { MinMaxInterface } from '../interfaces/api';

export class MinMax implements MinMaxInterface {

    min: number;

    max: number;

    static createFromObject(object: any): MinMax {

        let mm = new MinMax();

        if (object.min !== undefined) mm.min = object.min;
        if (object.max !== undefined) mm.max = object.max;

        return mm;
    }
}



// WEBPACK FOOTER //
// ./src/entities/min-max.ts